<!-- <footer class="site-footer">
  <div class="container footer-row">
    <div class="footer-copy">
      <h4>AURA GROUPS PRIVATE LIMITED</h4>
      <p>Premium construction, interior, finance, and travel solutions for discerning investors and project leaders.</p>
    </div>
    <div class="footer-links">
      <a routerLink="/home">Home</a>
      <a routerLink="/services">Services</a>
      <a routerLink="/gallery">Gallery</a>
      <a routerLink="/contact">Contact</a>
      <a routerLink="/dashboard">Dashboard</a>

    </div>
    <div class="social-row footer-social" aria-label="Footer social links">
      <a href="https://www.instagram.com/aura_promoters_and_developers?igsh=MTlueHUyeHdhaW56NA==" target="_blank" rel="noreferrer" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
      <a href="https://facebook.com" target="_blank" rel="noreferrer" aria-label="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
      <a href="https://linkedin.com" target="_blank" rel="noreferrer" aria-label="LinkedIn"><i class="fa-brands fa-linkedin-in"></i></a>
       <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube"><i class="fa fa-youtube-play" aria-hidden="true"></i></a>
    </div>
  </div>
</footer> -->

<footer class="site-footer">
  <div class="footer-container">
    
    <!-- Brand / About Column -->
    <div class="footer-brand-col">
      <div class="brand-title">
        <span class="brand-icon">✦</span>
        <h2>AURA Group Private Limited</h2>
      </div>
      <p class="brand-tagline">Construction • Real Estate • Financial</p>
      <p class="brand-description">
       We build custom, cross-industry enterprise technology that bridges technology with business vision. Our commitment is simple: delivering exceptional quality, seamless integration, and measurable value at every scale.
       </p>
    </div>

     <!-- Company Column -->
    <div class="footer-links-col">
      <h3>COMPANY</h3>
      <ul class="footer-links-list">
          <li><a routerLink="/home">Home</a></li>
     <li><a routerLink="/about">About Us</a></li>
     <li> <a routerLink="/services">Services</a></li>
     <li><a routerLink="/gallery">Gallery</a></li>
     <li><a routerLink="/contact">Contact</a></li>

      </ul>
    </div>


    <!-- Enterprise Divisions Column -->
    <div class="footer-links-col">
      <h3>OUR SERVICES</h3>
      <ul class="footer-links-list">
        <li><a (click)="openServiceJourney('Core Construction')">Core Construction</a></li>
        <li><a (click)="openServiceJourney('Interior & Exterior')">Interior & Exterior</a></li>
        <li><a (click)="openServiceJourney('DTCP Approvals')">DTCP Approvals</a></li>
        <li><a (click)="openServiceJourney('3D Design')">3D Design</a></li>
        <li><a (click)="openServiceJourney('Floor Plans')">Floor Plans</a></li>
        <li><a (click)="openServiceJourney('Real Estate')">Real Estate</a></li>
        <li><a (click)="openServiceJourney('Financial Services')">Financial Services</a></li>
      </ul>
    </div>

   
    <!-- Corporate Information / Cards Column -->
    <div class="footer-info-col">
      <h3>CONTACT INFORMATION</h3>
      <div class="info-cards-wrapper">
        
        <!-- Email Card -->
        <a href="mailto:auragroups8@gmail.com" class="info-card">
          <div class="card-icon">
            <i class="far fa-envelope"></i>
          </div>
          <div class="card-content">
            <span class="card-label">EMAIL</span>
            <span class="card-value">auragroups8&#64;gmail.com</span>
          </div>
          <div class="card-arrow">↗</div>
        </a>

        <!-- Phone Card -->
        <a href="tel:+918072489607" class="info-card">
          <div class="card-icon">
            <i class="fas fa-phone-alt"></i>
          </div>
          <div class="card-content">
            <span class="card-label">PHONE</span>
            <span class="card-value">+91 80724 89607</span>
          </div>
          <div class="card-arrow">↗</div>
        </a>

        <!-- Locations Card -->
        <a href="https://maps.app.goo.gl/up9YTB8W6nVfcrXz8" target="_blank" class="info-card">
          <div class="card-icon">
            <i class="fas fa-map-marker-alt"></i>
          </div>
          <div class="card-content">
            <span class="card-label">LOCATIONS</span>
            <span class="card-value"> Palani • Dindigul • TamilNadu </span>
          </div>
          <div class="card-arrow">↗</div>
        </a>

      </div>
    </div>

  </div>

  <!-- Bottom Bar -->
  <div class="footer-bottom">
    <div class="footer-bottom-container">
      <p class="copyright">© 2026 AURA GROUPS PRIVATE LIMITED. All Rights Reserved.</p>
      <ul class="bottom-links">
        <li><a routerLink="/login">Staff Login </a></li>
        <li><a href="#">Terms & Conditions</a></li>
        <li><div class="social-row footer-social" aria-label="Footer social links">
      <a href="https://www.instagram.com/aura_promoters_and_developers?igsh=MTlueHUyeHdhaW56NA==" target="_blank" rel="noreferrer" aria-label="Instagram"><i class="fa-brands fa-instagram"></i></a>
      <a href="Https://www.facebook.com/share/1VGp5kcFQU/" target="_blank" rel="noreferrer" aria-label="Facebook"><i class="fa-brands fa-facebook-f"></i></a>
      <a href="https://wa.me/918072489607" target="_blank" rel="noreferrer" aria-label="WhatsApp"><i class="fa-brands fa-whatsapp"></i></a>
       <a href="https://youtube.com" target="_blank" rel="noreferrer" aria-label="YouTube"><i class="fa-solid fa-circle-play"></i></a>
    </div></li>
      </ul>
    </div>
  </div>
</footer>